import React, { useCallback } from 'react';
import { useDispatchFunction } from 'utils/hooks/useDispatchFunction';
import { login } from 'modules/auth/actions';
import { Button } from 'rebass';

export const DevLoginButton = () => {
  const loginDevAction = useDispatchFunction(login);

  const loginDev = useCallback(() => {
    const username = import.meta.env.VITE_USERNAME;
    const password = import.meta.env.VITE_PASSWORD;
    if (!username || !password) {
      throw new Error(
        'Attempting to login as developer but missing ' +
          'VITE_USERNAME or VITE_PASSWORD environment variables',
      );
    }
    loginDevAction({
      username,
      password,
    });
  }, [loginDevAction]);

  return <Button onClick={loginDev}>Developer Login</Button>;
};
